import React, { useEffect, useRef, useState } from 'react';

interface FlyIconProps {
  getStartElement: () => Element | null | undefined;
  getTargetElement: () => Element | null | undefined;
  onAnimationEnd: () => void;
  children: React.ReactNode;
  duration?: number; // Allow custom animation duration
  flyStyles?: React.CSSProperties; // Allow custom styles
}

const defaultFlyStyles: React.CSSProperties = {
	position: 'fixed',
	pointerEvents: 'none',
	zIndex: 9999,
};

const FlyIcon: React.FC<FlyIconProps> = ({
	getStartElement,
	getTargetElement,
	onAnimationEnd,
	children,
	duration = 800,
	flyStyles = {},
}) => {
	const iconRef = useRef<HTMLDivElement | null>(null);
	const [animate, setAnimate] = useState(false);
	const [flyPosition, setFlyPosition] = useState({ x: 0, y: 0 });
	const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
 
	useEffect(() => {
		const startElement = getStartElement();
		const targetElement = getTargetElement();

		if (startElement && targetElement) {
			const startRect = startElement.getBoundingClientRect();
			const targetRect = targetElement.getBoundingClientRect();

			setStartPosition({ x: startRect.left, y: startRect.top });
			setFlyPosition({ x: targetRect.left - startRect.left, y: targetRect.top - startRect.top });

			const timer = setTimeout(() => {
				onAnimationEnd();
			}, duration); // Duration should match the CSS transition time

			return () => clearTimeout(timer);
		}
	}, [getStartElement, getTargetElement, onAnimationEnd, duration]);
	
	// element render到dom當中後再觸發動畫
	useEffect(() => {
		if (iconRef) {
			setAnimate(true);
		}
	}, [iconRef])

	return (
		<div
			ref={iconRef}
			style={{
				...defaultFlyStyles,
				...flyStyles,
				transition: `transform ${duration}ms ease-in-out, opacity ${duration}ms ease-in`,
				transform: animate
					? `translate(${flyPosition.x}px, ${flyPosition.y}px)`
					: 'none',
				opacity: animate
					? '0'
					: '1',
				left: `${startPosition.x}px`,
				top: `${startPosition.y}px`,
			}}
		>
			{children}
		</div>
	);
};

export default FlyIcon;
